// Core
import React, { useEffect } from 'react';
import { Button, Modal } from 'antd';

// Styles
import './styles.css';

interface ExcerptProps {
    onClose: () => void;
    open: boolean;
    context: Array<{ page_content: string }> | null;
}

const Excerpt: React.FC<ExcerptProps> = ({ onClose, open, context }) => {
    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <Modal
                title="Response Sources"
                visible={open}
                onCancel={handleClose}
                footer={[
                    <Button key="close" onClick={onClose} type="primary">
                        Close
                    </Button>,
                ]}
                className="__common_model_class"
            >
                <div className="__common_model_content">
                    <div className="____common_model_class_desc">
                        {context?.slice(0, 5).map((item, index) => (
                            <div className="__single_context" key={index}>
                                <h1>Section {index + 1}</h1>
                                <p>{item?.page_content}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Excerpt;
